export const navItems = [
  { path: '/', label: 'Catalog', icon: 'storefront' },
  { path: '/contact', label: 'Contact', icon: 'mail' },
];
